<template>
  <div>
    <!-- Interface State Table -->
    <table class="table align-items-center mb-0">
      <thead>
        <tr>
          <th class="text-sm">Interface</th>
          <th class="text-sm">Connection State</th>
          <th class="text-sm">Enable</th>
          <th class="text-sm">Speed</th>
          <th class="text-sm">Duplex</th>
          <th class="text-sm">Flow Control</th>
          <th class="text-sm">Input Rate</th>
          <th class="text-sm">Output Rate</th>
          <th class="text-sm">MAC Address</th>
          <th class="text-sm">Port Description</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="loading">
          <tr>
            <td colspan="10">
              <Skalaton />
            </td>
          </tr>
        </template>
        <template v-else-if="intfState?.interfaces && intfState.interfaces.length">
          <tr
            v-for="(intf, index) in intfState.interfaces"
            :key="index"
          >
            <td class="text-sm font-weight-bold">{{ getInterfaceWithDescription(intf.Interface) }}</td>
            <td class="text-sm">
              <span
                class="badge"
                :class="getConnectionClass(intf['Connection state'])"
                style="text-transform: uppercase; color: rgb(255 249 249) !important;"
              >
                {{ intf['Connection state'] || 'N/A' }}
              </span>
            </td>
            <td class="text-sm">
              <span
                class="badge"
                :class="getEnableClass(intf.Enable)"
                style="text-transform: uppercase; color: rgb(255 249 249) !important;"
              >
                {{ intf.Enable || 'N/A' }}
              </span>
            </td>
            <td class="text-sm">{{ intf.Speed || 'N/A' }}</td>
            <td class="text-sm">{{ intf.Duplex || 'N/A' }}</td>
            <td class="text-sm">
              <span
                class="badge"
                :class="getFlowClass(intf['Flow control'])"
                style="text-transform: uppercase; color: rgb(255 249 249) !important;"
              >
                {{ intf['Flow control'] || 'N/A' }}
              </span>
            </td>
            <td class="text-sm">{{ intf['Input rate'] || 'N/A' }}</td>
            <td class="text-sm">{{ intf['Output Rate'] || 'N/A' }}</td>
            <td class="text-sm font-monospace">{{ intf['MAC Address'] || 'N/A' }}</td>
            <td class="text-sm">{{ intf['Port Description'] || 'N/A' }}</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="10" class="text-center">No interface state data available</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'SintfStateTable',
  components: {
    Skalaton
  },
  props: {
    intfState: {
      type: Object,
      default: () => ({})
    },
    basicInfo: {
      type: Object,
      required: false,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    portDescriptions: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  methods: {
    getConnectionClass(status) {
      if (status === 'up') return 'bg-success';
      if (status === 'down') return 'bg-danger';
      return 'bg-secondary';
    },
    
    getEnableClass(status) {
      if (status === 'up') return 'bg-success';
      if (status === 'down') return 'bg-danger';
      return 'bg-secondary';
    },
    
    getFlowClass(status) {
      if (status === 'Off') return 'bg-secondary';
      if (status === 'On') return 'bg-success';
      return 'bg-warning';
    },

    getInterfaceWithDescription(interfaceName) {
      if (!interfaceName) return 'N/A';
      
      if (!this.portDescriptions || !this.portDescriptions.ports || !Array.isArray(this.portDescriptions.ports)) {
        return interfaceName;
      }
      
      const port = this.portDescriptions.ports.find(p => p.Interface === interfaceName);
      
      if (port && port.description && port.description.trim() !== '') {
        return `${interfaceName} - ${port.description}`;
      }
      
      return interfaceName;
    }
  }
}
</script>

